/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  function setNewsletterCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; domain=' + (window.location.hostname || '');
  }

  function hasNewsletterCookie(name, value) {
    if (!name) return false;
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    return cookies.some(function (c) {
      if (value) return c === name + '=' + value;
      return c.indexOf(name + '=') === 0;
    });
  }

  function getNewsletterTriggerWrap(popup) {
    return popup && popup.querySelector('[data-newsletter-trigger-wrap]');
  }

  function showNewsletterTrigger(popup) {
    var wrap = getNewsletterTriggerWrap(popup);
    var name = popup.getAttribute('data-cookie-name') || 'newsletter-1-popups';
    if (wrap && !hasNewsletterCookie(name + '-trigger-dismissed', '1')) {
      wrap.classList.add('is-visible');
    }
  }

  function hideNewsletterTrigger(popup) {
    var wrap = getNewsletterTriggerWrap(popup);
    if (wrap) wrap.classList.remove('is-visible');
  }

  // Newsletter popup close – delegated fallback (Klaviyo iframe can block theme handler)
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-newsletter] [data-close-modal]');
    if (!closeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var popup = closeBtn.closest('[data-newsletter]');
    var inner = popup && popup.querySelector('[data-popup-inner]');
    if (inner) {
      inner.style.opacity = '0';
      inner.style.display = 'none';
      var name = popup.getAttribute('data-cookie-name') || 'newsletter-1-popups';
      setNewsletterCookie(name, 'newsletter_is_closed', 365);
      showNewsletterTrigger(popup);
    }
  }, true);

  // Dismiss newsletter trigger badge
  document.addEventListener('click', function (e) {
    var dismissBtn = e.target.closest('[data-newsletter-trigger-dismiss]');
    if (!dismissBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var popup = dismissBtn.closest('[data-newsletter]');
    hideNewsletterTrigger(popup);
    var name = popup.getAttribute('data-cookie-name') || 'newsletter-1-popups';
    setNewsletterCookie(name + '-trigger-dismissed', '1', 14);
  }, true);

  // Newsletter popup trigger badge – show popup again after close
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-newsletter-trigger]');
    if (!trigger) return;
    e.preventDefault();
    var popup = trigger.closest('[data-newsletter]');
    var inner = popup && popup.querySelector('[data-popup-inner]');
    if (inner) {
      inner.style.display = 'block';
      inner.style.opacity = '1';
      hideNewsletterTrigger(popup);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-newsletter]').forEach(function (popup) {
      var name = popup.getAttribute('data-cookie-name');
      if (hasNewsletterCookie(name, 'newsletter_is_closed')) {
        var inner = popup.querySelector('[data-popup-inner]');
        if (inner) {
          inner.style.opacity = '0';
          inner.style.display = 'none';
        }
        showNewsletterTrigger(popup);
      } else {
        hideNewsletterTrigger(popup);
      }
    });
  });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // -------------------------------------------------------
  // Lights Switch – toggle between image 1 (lit) and image 2 (unlit)
  // Shown only when collection metafield `custom.show_switch` is true.
  // State is persisted in sessionStorage so it survives AJAX pagination.
  //
  // AJAX pagination replaces .js-grid's innerHTML via [data-products-grid].innerHTML,
  // so we observe the stable [data-products-grid] container rather than .js-grid.
  // -------------------------------------------------------

  var lightsSwitchObserver = null;

  function extractLightImagesFrom(root) {
    root.querySelectorAll('product-grid-item-image[data-grid-image="1"]').forEach(function (wrapper) {
      var tmpl = wrapper.querySelector('template');
      if (tmpl) {
        wrapper.appendChild(tmpl.content.cloneNode(true));
        tmpl.remove();
      }
    });
  }

  function applyLightsState(grid, isOff) {
    if (isOff) {
      extractLightImagesFrom(grid);
      grid.classList.add('lights-off');
    } else {
      grid.classList.remove('lights-off');
    }
  }

  function initLightsSwitch() {
    var switchBtn = document.querySelector('[data-lights-switch]');
    if (!switchBtn) return;

    // [data-products-grid] is the stable outer container.
    // .js-grid is inside it and gets fully replaced on AJAX pagination.
    var productsContainer = document.querySelector('[data-products-grid]');
    if (!productsContainer) return;

    // Restore persisted state
    var lightsOff = sessionStorage.getItem('lightsOff') === 'true';
    var grid = productsContainer.querySelector('.js-grid');
    if (grid && lightsOff) {
      applyLightsState(grid, true);
      switchBtn.setAttribute('aria-pressed', 'true');
    }

    // Guard against duplicate click listeners (button element is reused across AJAX navigations)
    if (switchBtn._lightsInitialized) return;
    switchBtn._lightsInitialized = true;

    switchBtn.addEventListener('click', function () {
      lightsOff = !lightsOff;
      sessionStorage.setItem('lightsOff', lightsOff ? 'true' : 'false');

      var currentGrid = productsContainer.querySelector('.js-grid');
      if (currentGrid) applyLightsState(currentGrid, lightsOff);

      switchBtn.setAttribute('aria-pressed', lightsOff ? 'true' : 'false');
    });

    // Watch [data-products-grid] – the stable container whose innerHTML gets
    // swapped by AJAX pagination. When a new .js-grid is inserted, apply state.
    if (lightsSwitchObserver) lightsSwitchObserver.disconnect();
    lightsSwitchObserver = new MutationObserver(function () {
      if (sessionStorage.getItem('lightsOff') !== 'true') return;
      var newGrid = productsContainer.querySelector('.js-grid');
      if (newGrid) applyLightsState(newGrid, true);
    });
    lightsSwitchObserver.observe(productsContainer, { childList: true, subtree: true });
  }

  // Run immediately (script is deferred so DOM is ready) and on theme navigations
  initLightsSwitch();
  document.addEventListener('page:load', initLightsSwitch);

  // Product card: mobile arrows + desktop hover columns (max 4 slides; matches theme cycle limit)
  var PGI_MAX_SLIDES = 4;
  var MOBILE_BREAKPOINT = (window.theme && window.theme.sizes && window.theme.sizes.medium) || 768;
  var pgiWarmupObserver = null;

  function eagerLoadGridImage(imageEl) {
    if (!imageEl) return;
    if (typeof imageEl.eagerLoad === 'function') {
      imageEl.eagerLoad();
    }
    var img = imageEl.querySelector('img');
    if (img) {
      img.setAttribute('loading', 'eager');
      if (typeof img.decode === 'function') {
        img.decode().catch(function () {});
      }
    }
  }

  function warmPgiImages(pgi) {
    if (!pgi || window.innerWidth < MOBILE_BREAKPOINT) return;
    var holder = pgi.querySelector('[data-grid-images]');
    if (!holder) return;
    var images = holder.querySelectorAll('[data-grid-image]');
    var count = Math.min(images.length, PGI_MAX_SLIDES);
    if (count < 2) return;
    for (var i = 0; i < count; i++) {
      eagerLoadGridImage(images[i]);
    }
    pgi.setAttribute('data-pgi-warm-ready', '');
  }

  function ensurePgiWarmupObserver() {
    if (pgiWarmupObserver) return;
    pgiWarmupObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var pgi = entry.target;
        warmPgiImages(pgi);
        pgiWarmupObserver.unobserve(pgi);
      });
    }, {
      rootMargin: '200px 0px',
      threshold: 0.1
    });
  }

  function observePgiWarmup(scope) {
    if (window.innerWidth < MOBILE_BREAKPOINT) return;
    ensurePgiWarmupObserver();
    var root = (scope && typeof scope.querySelectorAll === 'function') ? scope : document;
    root.querySelectorAll('product-grid-item-variant.product-grid-item--hover-zones:not([hidden]):not([data-pgi-warm-observed])').forEach(function (pgi) {
      pgi.setAttribute('data-pgi-warm-observed', '');
      pgiWarmupObserver.observe(pgi);
    });
  }

  function teardownPgiDesktopHoverZones() {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    document.querySelectorAll('product-grid-item-variant.product-grid-item--hover-zones').forEach(function (pgi) {
      var holder = pgi.querySelector('[data-grid-images]');
      var ov = holder && holder.querySelector('.product-grid-item__hover-zones');
      if (ov) ov.remove();
      pgi.removeAttribute('data-pgi-zones-ready');
    });
  }

  function initPgiDesktopHoverZones(scope) {
    if (window.innerWidth < MOBILE_BREAKPOINT) return;
    var root = (scope && typeof scope.querySelectorAll === 'function') ? scope : document;

    var run = function () {
      if (window.innerWidth < MOBILE_BREAKPOINT) return;
      root.querySelectorAll('product-grid-item-variant.product-grid-item--hover-zones').forEach(function (pgi) {
        var holder = pgi.querySelector('[data-grid-images]');
        if (!holder || typeof pgi.changeImage !== 'function') return;
        var images = holder.querySelectorAll('[data-grid-image]');
        var n = Math.min(images.length, PGI_MAX_SLIDES);
        if (n < 2) return;
        if (holder.querySelector('.product-grid-item__hover-zones')) {
          pgi.setAttribute('data-pgi-zones-ready', '');
          return;
        }
        pgi.removeAttribute('data-pgi-zones-ready');
        pgi.removeAttribute('data-pgi-warm-observed');
        pgi.removeAttribute('data-pgi-warm-ready');
        var overlay = document.createElement('div');
        overlay.className = 'product-grid-item__hover-zones';
        overlay.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < n; i++) {
          var zone = document.createElement('span');
          zone.className = 'product-grid-item__hover-zone';
          overlay.appendChild(zone);
        }
        holder.appendChild(overlay);
        function applyHoverIndex(index) {
          if (window.innerWidth < MOBILE_BREAKPOINT) return;
          var i = parseInt(index, 10);
          if (isNaN(i) || i < 0 || i >= n) return;
          var imgEl = images[i];
          eagerLoadGridImage(imgEl);
          if (i + 1 < n) eagerLoadGridImage(images[i + 1]);
          pgi.changeImage(i);
        }
        overlay.querySelectorAll('.product-grid-item__hover-zone').forEach(function (zone, idx) {
          zone.addEventListener('pointerenter', function (e) {
            if (e.pointerType === 'touch') return;
            applyHoverIndex(idx);
          });
        });
        if (!holder._pgiMouseleaveBound) {
          holder._pgiMouseleaveBound = true;
          holder.addEventListener('mouseleave', function () {
            if (window.innerWidth < MOBILE_BREAKPOINT) return;
            if (typeof pgi.resetSlideshow === 'function') pgi.resetSlideshow();
          });
        }
        warmPgiImages(pgi);
        pgi.setAttribute('data-pgi-zones-ready', '');
      });
    };

    var p = customElements && typeof customElements.whenDefined === 'function'
      ? customElements.whenDefined('product-grid-item-variant')
      : Promise.resolve();
    p.then(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(run);
      });
    });
  }

  function syncPgiHoverZonesForViewport(scope) {
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      teardownPgiDesktopHoverZones();
      if (pgiWarmupObserver) {
        pgiWarmupObserver.disconnect();
      }
    } else {
      initPgiDesktopHoverZones(scope);
      observePgiWarmup(scope);
    }
  }

  function schedulePgiRefresh(scope) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        syncPgiHoverZonesForViewport(scope);
      });
    });
  }

  function initAlpineProductCardForms(scope) {
    if (typeof Alpine === 'undefined' || typeof Alpine.initTree !== 'function') return;
    var root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    root.querySelectorAll('product-grid-item-variant [x-data*="productAddButtonForm"]').forEach(function (formRoot) {
      if (formRoot._x_dataStack && formRoot._x_dataStack.length) return;
      Alpine.initTree(formRoot);
    });
  }

  function isAlpineProductAddReady(formRoot) {
    if (!formRoot || !formRoot._x_dataStack || !formRoot._x_dataStack.length) return false;
    var data = formRoot._x_dataStack[formRoot._x_dataStack.length - 1];
    return !!(data && typeof data.handleClickAddButton === 'function');
  }

  function showProductCardAddError(container, message) {
    if (!container) return;
    var errorDisplay = container.querySelector('[data-error-display]');
    if (!errorDisplay) return;
    errorDisplay.innerHTML = '<div class="errors">' + message + '</div>';
    errorDisplay.style.display = 'block';
    window.setTimeout(function () {
      errorDisplay.innerHTML = '&nbsp;';
      errorDisplay.style.display = '';
    }, 5000);
  }

  function handleProductCardAddToCart(btn) {
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;

    var form = btn.closest('form');
    if (!form) return;

    var cartRoute = window.theme && window.theme.routes && window.theme.routes.cart;
    if (!cartRoute) return;

    btn.classList.add('loading');
    btn.classList.remove('has-success');

    fetch(cartRoute + '/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorBody) {
            throw errorBody;
          });
        }
        return response.json();
      })
      .then(function (variant) {
        btn.classList.remove('loading');
        btn.classList.add('has-success');
        window.setTimeout(function () {
          btn.classList.remove('has-success');
        }, 2000);

        document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
          bubbles: true,
          detail: { variant: variant }
        }));

        return fetch(cartRoute + '.js').then(function (response) {
          return response.json();
        }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: { cart: cart }
          }));
        });
      })
      .catch(function (error) {
        btn.classList.remove('loading');
        var message = 'Network error: please try again';
        if (error && typeof error.description === 'string') {
          message = error.description;
        } else if (error && typeof error.message === 'string') {
          message = error.message;
        }
        showProductCardAddError(btn.closest('product-grid-item-variant'), message);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('product-grid-item-variant [data-add-to-cart]');
    if (!btn) return;

    var formRoot = btn.closest('[x-data*="productAddButtonForm"]');
    if (isAlpineProductAddReady(formRoot)) return;

    event.preventDefault();
    event.stopPropagation();
    handleProductCardAddToCart(btn);
  }, true);

  function scheduleProductCardFormRefresh(scope) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        initAlpineProductCardForms(scope);
      });
    });
  }

  function ensurePgiGridObserver() {
    var productsContainer = document.querySelector('[data-products-grid]');
    if (!productsContainer || productsContainer._pgiGridObserverBound) return;

    productsContainer._pgiGridObserverBound = true;
    var gridRefreshTimer = null;
    var gridObserver = new MutationObserver(function () {
      window.clearTimeout(gridRefreshTimer);
      gridRefreshTimer = window.setTimeout(function () {
        schedulePgiRefresh(productsContainer);
        scheduleProductCardFormRefresh(productsContainer);
      }, 50);
    });
    gridObserver.observe(productsContainer, { childList: true, subtree: true });
  }

  function bindPgiRefreshEvents() {
    document.addEventListener('DOMContentLoaded', function () {
      ensurePgiGridObserver();
      syncPgiHoverZonesForViewport();
      scheduleProductCardFormRefresh(document);
    });
    document.addEventListener('page:load', function () {
      ensurePgiGridObserver();
      schedulePgiRefresh(document);
      scheduleProductCardFormRefresh(document);
    });
    window.addEventListener('theme:section:update', function () {
      ensurePgiGridObserver();
      schedulePgiRefresh(document);
      scheduleProductCardFormRefresh(document);
    });
    document.addEventListener('theme:resize:width', syncPgiHoverZonesForViewport);
    document.addEventListener('theme:related-products:added', function (e) {
      schedulePgiRefresh(e.target);
    });
    document.addEventListener('theme:recent-products:added', function (e) {
      schedulePgiRefresh(e.target);
    });
  }

  bindPgiRefreshEvents();
  ensurePgiGridObserver();
  syncPgiHoverZonesForViewport();
  scheduleProductCardFormRefresh(document);

  function pgiAdvanceSlide(pgi, direction) {
    if (typeof pgi.changeImage !== 'function') return;
    var imagesHolder = pgi.querySelector('[data-grid-images]');
    if (!imagesHolder) return;
    var images = imagesHolder.querySelectorAll('[data-grid-image]');
    var count = Math.min(images.length, PGI_MAX_SLIDES);
    if (count < 2) return;
    var currentEl = imagesHolder.querySelector('[data-grid-image][data-grid-current-image]');
    var currentIndex = currentEl ? parseInt(currentEl.getAttribute('data-grid-image'), 10) : 0;
    var nextIndex = (currentIndex + direction + count) % count;
    var targetImage = images[nextIndex];
    if (targetImage && typeof targetImage.eagerLoad === 'function') {
      targetImage.eagerLoad();
    }
    pgi.changeImage(nextIndex);
  }

  document.addEventListener('click', function (e) {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var btn = e.target.closest('[data-pgi-prev], [data-pgi-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var pgi = btn.closest('product-grid-item-variant');
    if (!pgi) return;
    pgiAdvanceSlide(pgi, btn.hasAttribute('data-pgi-prev') ? -1 : 1);
  }, true);

  var pgiSwipeStartX = null;
  var pgiSwipeStartY = null;
  var pgiSwipeHolder = null;
  var PGI_SWIPE_MIN_PX = 45;

  document.addEventListener('touchstart', function (e) {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    var holder = e.target.closest('[data-grid-images]');
    if (!holder) return;
    var pgi = holder.closest('product-grid-item-variant');
    if (!pgi || typeof pgi.changeImage !== 'function') return;
    var images = holder.querySelectorAll('[data-grid-image]');
    if (Math.min(images.length, PGI_MAX_SLIDES) < 2) return;
    if (e.touches.length !== 1) return;
    pgiSwipeStartX = e.touches[0].clientX;
    pgiSwipeStartY = e.touches[0].clientY;
    pgiSwipeHolder = holder;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    if (pgiSwipeStartX == null || !pgiSwipeHolder) return;
    if (e.changedTouches.length !== 1) {
      pgiSwipeStartX = null;
      pgiSwipeHolder = null;
      return;
    }
    var holder = pgiSwipeHolder;
    var endX = e.changedTouches[0].clientX;
    var endY = e.changedTouches[0].clientY;
    var dx = endX - pgiSwipeStartX;
    var dy = endY - pgiSwipeStartY;
    pgiSwipeStartX = null;
    pgiSwipeHolder = null;
    if (Math.abs(dx) < PGI_SWIPE_MIN_PX) return;
    if (Math.abs(dy) > Math.abs(dx) * 0.75 && Math.abs(dy) > 40) return;
    var pgi = holder.closest('product-grid-item-variant');
    if (!pgi) return;
    var direction = dx < 0 ? 1 : -1;
    pgiAdvanceSlide(pgi, direction);
    var link = holder.closest('a[data-grid-link]');
    if (link) {
      var once = function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        link.removeEventListener('click', once, true);
      };
      link.addEventListener('click', once, true);
    }
  }, { passive: true });

  var CIRCLES_DRAG_MIN_PX = 10;
  var CIRCLES_MOUSE_DRAG_MIN_PX = 4;

  function suppressNextCollectionCircleClick(scroller) {
    var once = function (ev) {
      if (!ev.target.closest('.collection-circles__item')) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      scroller.removeEventListener('click', once, true);
    };
    scroller.addEventListener('click', once, true);
    setTimeout(function () {
      scroller.removeEventListener('click', once, true);
    }, 50);
  }

  function initCollectionCirclesScrollers(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var scrollers = root.querySelectorAll('[data-collection-circles-scroller]');

    scrollers.forEach(function (scroller) {
      if (scroller.dataset.circlesScrollInit === 'true') return;
      scroller.dataset.circlesScrollInit = 'true';

      var touchStartX = null;
      var touchStartY = null;
      var touchDragged = false;

      var viewport = scroller.closest('.collection-circles__viewport');
      var scrollbar = viewport && viewport.querySelector('[data-custom-scrollbar]');
      var scrollbarTrack = viewport && viewport.querySelector('[data-custom-scrollbar-track]');

      function hasOverflow() {
        return scroller.scrollWidth - scroller.clientWidth > 1;
      }

      function updateScrollbar() {
        var overflow = hasOverflow();
        scroller.classList.toggle('is-scrollable', overflow);
        if (!scrollbar || !scrollbarTrack) return;

        scrollbar.classList.toggle('hide', !overflow);
        if (!overflow) return;

        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var trackPct = Math.max(5, (scroller.clientWidth / scroller.scrollWidth) * 100);
        scrollbar.style.setProperty('--track-width', trackPct + '%');

        var trackWidthPx = scrollbarTrack.clientWidth || (scrollbar.clientWidth * trackPct / 100);
        var position = maxScroll > 0
          ? (Math.abs(scroller.scrollLeft) / maxScroll) * (scrollbar.clientWidth - trackWidthPx)
          : 0;
        if (isNaN(position) || position < 0) position = 0;
        scrollbar.style.setProperty('--position', Math.round(position) + 'px');
      }

      updateScrollbar();
      window.addEventListener('resize', updateScrollbar);
      scroller.addEventListener('scroll', updateScrollbar, { passive: true });

      scroller.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchDragged = false;
      }, { passive: true });

      scroller.addEventListener('touchmove', function (e) {
        if (touchStartX == null || e.touches.length !== 1) return;
        var dx = Math.abs(e.touches[0].clientX - touchStartX);
        var dy = Math.abs(e.touches[0].clientY - touchStartY);
        if (dx > CIRCLES_DRAG_MIN_PX && dx > dy) touchDragged = true;
      }, { passive: true });

      scroller.addEventListener('touchend', function () {
        if (touchDragged) suppressNextCollectionCircleClick(scroller);
        touchStartX = null;
        touchDragged = false;
      }, { passive: true });

      if (!window.matchMedia('(pointer: fine)').matches) return;

      var mouseDown = false;
      var mouseStartX = 0;
      var mouseStartScroll = 0;
      var mouseMoved = 0;
      var lastClientX = 0;
      var lastMoveTime = 0;
      var velocityX = 0;
      var momentumRaf = null;

      function stopMomentum() {
        if (momentumRaf) {
          cancelAnimationFrame(momentumRaf);
          momentumRaf = null;
        }
      }

      function endDragStyles() {
        scroller.classList.remove('is-mouse-dragging');
      }

      function runMomentum(initialVelocity) {
        stopMomentum();
        var velocity = initialVelocity;
        var lastTs = null;

        function step(ts) {
          if (lastTs == null) lastTs = ts;
          var dt = Math.min(ts - lastTs, 32);
          lastTs = ts;

          if (Math.abs(velocity) < 0.02) {
            endDragStyles();
            momentumRaf = null;
            return;
          }

          scroller.scrollLeft += velocity * dt;
          velocity *= Math.pow(0.0025, dt / 1000);
          momentumRaf = requestAnimationFrame(step);
        }

        scroller.classList.add('is-mouse-dragging');
        momentumRaf = requestAnimationFrame(step);
      }

      function onMouseMove(e) {
        if (!mouseDown) return;
        var dx = e.clientX - mouseStartX;
        var now = performance.now();
        var frameDx = e.clientX - lastClientX;
        var frameDt = now - lastMoveTime;

        if (frameDt > 0 && frameDt < 80) {
          velocityX = frameDx / frameDt;
        }

        lastClientX = e.clientX;
        lastMoveTime = now;

        if (Math.abs(dx) > CIRCLES_MOUSE_DRAG_MIN_PX) {
          mouseMoved = Math.abs(dx);
          scroller.classList.add('is-mouse-dragging');
        }
        if (mouseMoved > CIRCLES_MOUSE_DRAG_MIN_PX) {
          e.preventDefault();
          scroller.scrollLeft = mouseStartScroll - dx;
        }
      }

      function onMouseUp() {
        if (!mouseDown) return;
        mouseDown = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);

        if (mouseMoved > CIRCLES_MOUSE_DRAG_MIN_PX) {
          suppressNextCollectionCircleClick(scroller);
          var releaseVelocity = -velocityX;
          if (Math.abs(releaseVelocity) > 0.15) {
            runMomentum(releaseVelocity);
          } else {
            endDragStyles();
          }
        } else {
          endDragStyles();
        }

        mouseMoved = 0;
        velocityX = 0;
      }

      scroller.addEventListener('mousedown', function (e) {
        if (e.button !== 0 || !hasOverflow()) return;
        stopMomentum();
        endDragStyles();
        mouseDown = true;
        mouseMoved = 0;
        velocityX = 0;
        mouseStartX = e.clientX;
        mouseStartScroll = scroller.scrollLeft;
        lastClientX = e.clientX;
        lastMoveTime = performance.now();
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      scroller.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });

      scroller.addEventListener('wheel', function (e) {
        if (!hasOverflow()) return;
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        stopMomentum();
        endDragStyles();
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCollectionCirclesScrollers(document);
    });
  } else {
    initCollectionCirclesScrollers(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initCollectionCirclesScrollers(e.target);
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
